/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@mui/material"
import { Box } from "@mui/system"
import { useCallback, useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { PrivateLoader } from "src/components/templates"
import BackButton from "src/components/UI/CustomUI/atoms/BackButton"
import { invoiceActions, itemsActions, jobActions, territoryActions } from "src/ducks/actions"
import { getInvoicePreview } from 'src/ducks/invoice/selectors'
import { getJob } from "src/ducks/selectors"

import { ITEM_STATUS } from "src/helpers"
import { usePaddingWrapper } from "src/hooks"
import { PreviewInvoiceContext } from "./context"
import { previewInvoiceTypes } from "./context/types"
import InvoicePrice from "./InvoicePrice"
import SendingInfo from "./SendingInfo"

import AddPayerContact from './AddPayerContact'
import styles from './styles.module.scss'

const PreviewInvoice = () => {
  const { setHasPadding } = usePaddingWrapper()
  const { dispatch: dispatchContext, state: { pageLoading } } = useContext(PreviewInvoiceContext)

  const { jobId } = useParams()
  const dispatch = useDispatch()
  const job = useSelector(getJob())
  const invoicePreview = useSelector(getInvoicePreview())
  const [reload, setReload] = useState(false)
  const contactPayer = job?.properties?.contacts?.filter((contact) => (contact as any).isPayer)

  const payer = invoicePreview && invoicePreview?.preparedFor?.payer ? true 
  : contactPayer? contactPayer.length > 0 ? true : false : false 


  const fetchJob = useCallback(() => {
    if (jobId) {
      dispatchContext({ type: previewInvoiceTypes.SET_VALUE, payload: { attr: 'pageLoading', value: true } })

      dispatch(jobActions.fetchJob(jobId,
        (_succ: boolean) => {
          dispatchContext({ type: previewInvoiceTypes.SET_VALUE, payload: { attr: 'pageLoading', value: false } })
        }))
    }
  }, [])

  const fetchTerritory = useCallback(() => {
    if (job) {
      dispatchContext({ type: previewInvoiceTypes.SET_VALUE, payload: { attr: 'pageLoading', value: true } })

      dispatch(territoryActions.getTerritory(job?.properties?.territory.id,
        (_succ: boolean) => {
          dispatchContext({ type: previewInvoiceTypes.SET_VALUE, payload: { attr: 'pageLoading', value: false } })
        }))
    }
  }, [])

  const fetchItems = () => {
    dispatch(itemsActions.fetchItemsByCategory({
      params: { jobId, status: ITEM_STATUS.ACCEPTED }
    }, (_succ) => {

    }))
  }


  const fetchInvoicePreview = useCallback(() => {
    if (jobId) {
      dispatchContext({ type: previewInvoiceTypes.SET_VALUE, payload: { attr: 'pageLoading', value: true } })

      dispatch(invoiceActions.getInvoicePreview({ params: { jobId: jobId }},
        (_succ: boolean) => {
          dispatchContext({ type: previewInvoiceTypes.SET_VALUE, payload: { attr: 'pageLoading', value: false } })
        }))
    }
  }, [])



 const onReloadHandle = () => {
  setReload(true)
}

useEffect(() => {
  if(reload){
    fetchJob()
    fetchInvoicePreview()
    setHasPadding(false)
  }
}, [reload])


  useEffect(() => {
    fetchJob()
    fetchItems()
    fetchTerritory()
    fetchInvoicePreview()
    setHasPadding(false)
  }, [])

  return (
    <PrivateLoader loading={pageLoading}>
      <Box>
        <Grid container className={styles.PreviewInvoice__container}>
          <Grid item container direction="column" spacing={3} xs={5} className={styles.PreviewInvoice__left}>
            <Grid item marginBottom={2}>
              <BackButton to={`/jobs/${jobId}`} />
            </Grid>
            {(payer)? <SendingInfo /> : <AddPayerContact onReload={onReloadHandle} /> }
            
          </Grid>
          <InvoicePrice />
        </Grid>
      </Box>
    </PrivateLoader >

  )
}

export default PreviewInvoice